<!--[title]="getTooltip()"-->

@if (!isError) {

  <img [src]="url"
       [height]="height"
       (error)="onImageError()"
       (load)="onImageLoad()"
       (click)="displayOriginalImage()"
       class="cursor rounded">
  @if (openable) {
    <dx-popup
      [title]="title"
      [(visible)]="displayOriginalImg"
      (onHiding)="closeDialog()"
      [showTitle]="true"
      [showCloseButton]="true"
      [hideOnOutsideClick]="false"
      [resizeEnabled]="true"
      width="auto"
      height="auto"
      [maxHeight]="600"
      [maxWidth]="800"
      [minWidth]="400">
      <!-- urlOriginal n'est renseignée qu'à l'ouverture de la fenêtre. Sans cette garde, l'img se montait avec un
           src vide, déclenchait (error) et faisait basculer isError : la vignette, pourtant correctement chargée,
           disparaissait avec elle. dx-popup diffère déjà le rendu de son contenu, la garde reste un filet explicite. -->
      <div *dxTemplate="let data of 'content'">
        @if (urlOriginal) {
          <img [src]="urlOriginal"
               height="256"
               (error)="onOriginalImageError()"
               class="rounded">
        }
      </div>
    </dx-popup>
  }
}

@if (isError && !_displayNoImage) {
  <img [src]="noImageUrl"
       [height]="height"
       class="rounded">
}


